module.exports = __webpack_public_path__ + "static/media/19288274521644843680room.52062e59.jpg";